export default class CouponClone {
	constructor() {
		this.init();
	}

	init() {
		const element = document.querySelector('[data-coupon-clone]');

		if (!element) {
			return;
		}

		const fakeInput = element.querySelector('[name="clone_coupon_code"]');
		const fakeSubmit = element.querySelector('[name="clone_coupon_button"]');

		const input = document.querySelector('[name="coupon_code"]');
		const submit = document.querySelector('[name="apply_coupon"]');

		fakeSubmit.addEventListener('click', (e) => {
			e.preventDefault();

			const couponCode = fakeInput.value;

			if (couponCode === '') {
				return;
			}

			input.value = couponCode;
			submit.dispatchEvent(new Event('click'));
		});
	}
}
